import $ from 'jquery';
/* share social */
$(function() {
    const toggle = $('.socialShareToggle');

    toggle.click(function(event) {
        event.preventDefault();
        $(this)
            .siblings('.socialShareContent')
            .toggleClass('__active');
    });
});
